import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { StepsModule } from 'primeng/steps';
import { MenuItem } from 'primeng/api';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SimplePdfViewerComponent, SimplePDFBookmark } from 'simple-pdf-viewer';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Message, ConfirmationService } from 'primeng/primeng';
import { Alert } from 'selenium-webdriver';
import { StoreService } from '../store.service';


@Component({
  selector: 'app-doc-post',
  templateUrl: './doc-post.component.html',
  styleUrls: ['./doc-post.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [ApiService, ConfirmationService]
})
export class DocPostComponent implements OnInit {
  steps: MenuItem[];
  activeIndex: number = 3;
  qboDocumentLines: any = [];
  rowGroupMetadata: any;
  msgs: Message[] = [];
  ScanPdfPath: any;
  loadingMessage: any = "Loading...";
  connectCompanyMessage: any = "";
  isViewerHidden: any = false;
  display: boolean = false;
  qboResponse: any = [];
  qboResponseLabel:string;
  dialogEditVisible: boolean = false;
  isaouthrize: boolean = false;
  filepath: string;

  isJob: boolean = false;
  isClass: boolean = false;
  isAccountDetail: boolean = true;
  isItemDetail: boolean = false;
  @ViewChild(SimplePdfViewerComponent) private pdfViewer: SimplePdfViewerComponent;
  // bookmarks: SimplePDFBookmark[] = [];

  constructor(private router: Router, private api: ApiService, private http: HttpClient, private spinner: NgxSpinnerService,
    private confirmationService: ConfirmationService, private ss: StoreService) {
  }

  validateConnectCompany() {

    this.api.get('Rah/GetByAccountID', '').subscribe(
      (res: {}) => this.sucessQboMaster(res),
      error => this.failedQboMaster(<any>error));
  }

  failedQboMaster(res: any) {

  }

  sucessQboMaster(res: any) {
    console.log(res);
    if (res.StatusCode == 0) {

      var companyName = res.Data[0].CompanyName;
      if (companyName == '' || companyName == null) {
        this.connectCompanyMessage = "No company is connected, Connect a company from Switch Company menu";
      }
      this.isJob = res.Data[0].IsJob;
      this.isClass = res.Data[0].IsClass;
      this.isAccountDetail = res.Data[0].IsAccountDetail;
      this.isItemDetail = res.Data[0].IsItemDetail;
    }

  }

  ngOnInit() {

    this.ss.storePageName('/docpost');
    this.validateConnectCompany();
    this.steps = [
      {
        label: 'Map Supplier Default Account',
        command: (event: any) => {
          this.ss.storePageName('/mapaccount');
          this.activeIndex = 0;
          this.router.navigateByUrl('/mapaccount');
        }
      },
      {
        label: 'Upload Document',
        command: (event: any) => {
          this.ss.storePageName('/docupload');
          this.activeIndex = 1;
          this.router.navigateByUrl('/docupload');
        }
      },
      {
        label: 'Review and Approve',
        command: (event: any) => {
          this.ss.storePageName('/docreview');
          this.activeIndex = 2;
          this.router.navigateByUrl('/docreview');
        }
      },
      {
        label: 'Post To Accounting System',
        command: (event: any) => {
          this.ss.storePageName('/docpost');
          this.activeIndex = 3;
          this.router.navigateByUrl('/docpost');
        }
      }
    ];

    this.getDocumentToBill();
  }


  getDocumentToBill() {

    this.spinner.show();
    this.api.get('Scan/GetQboDocumentToBill_New', '').subscribe(
      (res: {}) => this.sucessDocumentToBill(res),
      error => this.failedDocumentToBill(<any>error));

  }

  sucessDocumentToBill(resp: any) {
    console.log(resp);
    this.qboDocumentLines = resp.Data;
    this.spinner.hide();

    this.selectAllAsDefault();
  }

  failedDocumentToBill(resp: any) {
    console.log(resp);
    this.spinner.hide();
  }


  onChangeSelecToBillApprove(event: any, hdr: any) {

  }

  // how to open PDF document
  openDocument1(document: File) {
    const fileReader: FileReader = new FileReader();
    fileReader.onload = () => {

      this.pdfViewer.openDocument(new Uint8Array(fileReader.result as any));
    };
    fileReader.readAsArrayBuffer(document);
  }

  showPdf(value: any) {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');

    this.http.get(this.api.apiBaseUrl + 'Scan/GetQbDocumentFile?qboDocumentID=' + value.DocumentID, { headers: headers, responseType: 'blob' }).subscribe(
      (res: {}) => this.sucessDocumentFile(res),
      error => this.failedDocumentFile(<any>error));
  }
 
  sucessDocumentFile(resp: any) {
   

    var file = new Blob([resp], { type: 'application/pdf' });
    var fileURL = URL.createObjectURL(file);
    // window.open(fileURL);
    const win = window.open(fileURL , 'View Pdf', 'width=800,height=700');

    win.focus();

  }


  // showPdf(value: any) {
  //   let headers = new HttpHeaders();
  //   headers = headers.set('Accept', 'application/pdf');

  //   this.http.get(this.api.apiBaseUrl + 'Scan/GetQbDocumentFile?qboDocumentID=' + value.DocumentID, { headers: headers, responseType: 'blob' }).subscribe(
  //     (res: {}) => this.sucessDocumentFile(res),
  //     error => this.failedDocumentFile(<any>error));
  // }




  viewPdf(value: any) {

    this.api.get('Scan/GetQboDocumentFilePath?qboDocumentID=', value.DocumentID).subscribe(
      (res: {}) => this.sucessDocumentFilePath(res),
      error => this.failedDocumentFile(<any>error));

  }

  sucessDocumentFilePath(resp: any) {

    console.log(resp);
    const win = window.open(this.api.apiPreBaseUrl + resp, 'View Pdf', 'width=800,height=700');
    win.focus();
    console.log(resp);
  }


  DeAproveRecord(record: any) {

    this.confirmationService.confirm({
      message: 'Are you sure want to send the selected record back to review again?',
      accept: () => {
        this.spinner.show();
        this.loadingMessage = "Please wait..";
        this.api.post('Qbo/ApproveQboDocument', { 'DocumentID': record.DocumentID, 'Approve': false }).subscribe(
          (res1: {}) => this.successDeleteRecord(res1),
          error => this.failedDeleteRecord(<any>error));
      },
      reject: () => {
        //this.qboAccountIDSelected = 0;
      }
    });

  }

  successDeleteRecord(res: any) {
    this.spinner.hide();
    if (res.StatusCode == 0) {
      this.getDocumentToBill();
    }

  }

  failedDeleteRecord(res: any) {
    this.spinner.hide();
  }



  // sucessDocumentFile(resp: any) {
  //   this.display = true;
  //   this.openDocument1(resp);
  // }

  failedDocumentFile(resp: any) {
    this.spinner.hide();
  }

  selectAllAsDefault() {
    this.qboDocumentLines.forEach(element => {
      element.SelectToBill = true;

    });
  }

  onChangeApproveAll(event: any) {

    this.qboDocumentLines.forEach(element => {
      element.SelectToBill = event.target.checked;

    });
  }

  onChangeApprove(event: any, hdr: any) {
    console.log(hdr.DocumentID);

    var lines = this.qboDocumentLines.filter(xx => xx.DocumentID == hdr.DocumentID);
    if (lines != null) {
      lines.forEach(element => {
        element.SelectToBill = event.target.checked;

      });

    }

  }

  postToExcel() {
    var qboSelectedDocument = this.qboDocumentLines.filter(xx => xx.SelectToBill == true);

    if (qboSelectedDocument == null) {

      this.msgs = [];
      this.msgs.push({ severity: 'Info', summary: 'Please select a document atleast', detail: 'Mandatory.' });
      return;
    }
     this.confirmationService.confirm({
      message: 'Are you sure that you want to post all selected document(s) to excel sheet',
      accept: () => {
        this.spinner.show();
        this.loadingMessage = "Posting to Excel...";
        this.api.post('Rah/PostToExcelSheets', qboSelectedDocument).subscribe(
          (res1: {}) => this.successCreateBill(res1,'EXCEL'),
          error => this.failedCreateBill(<any>error));
      },
      reject: () => {
        //this.qboAccountIDSelected = 0;
      }
    });
  }

  postToQBO() {

    this.qboResponse = [];

    this.qboDocumentLines.forEach(element => {
      element.IsClass = this.isClass;
      element.IsJob = this.isJob;
      element.isAccountDetail = this.isAccountDetail;
      element.isItemDetail = this.isItemDetail;

    });
    // public bool? IsClass { get; set; }
    // public bool? IsJob { get; set; }

    var qboSelectedDocument = this.qboDocumentLines.filter(xx => xx.SelectToBill == true);

    if (qboSelectedDocument == null) {

      this.msgs = [];
      this.msgs.push({ severity: 'Info', summary: 'Please select a document atleast', detail: 'Mandatory.' });
      return;
    }

    this.confirmationService.confirm({
      message: 'Are you sure that you want to post all selected document(s) to RAH',
      accept: () => {
        this.spinner.show();
        this.loadingMessage = "Posting to RAH...";
        this.api.post('Rah/CreateBill_New', qboSelectedDocument).subscribe(
          (res1: {}) => this.successCreateBill(res1),
          error => this.failedCreateBill(<any>error));
      },
      reject: () => {
        //this.qboAccountIDSelected = 0;
      }
    });

  }

  successCreateBill(resp: any,label='RAH') {
    this.spinner.hide();
    this.msgs = [];

    this.dialogEditVisible = false;
    this.openRespWindow(resp,label);

  }

//NP 20 Nov 2024
  // successCreateBill(resp: any) {
  //   this.spinner.hide();
  //   this.msgs = [];

  //   this.dialogEditVisible = false;
  //   this.openRespWindow(resp);
  //   this.getDocumentToBill();
  // }

  openRespWindow(resp: any,label="RAH") {
    resp.Data.forEach(element => {
      this.qboResponse.push(
        {
          'InvoiceNo': element.InvoiceNo,
          'Supplier': element.Supplier,
          'ReponseFromXero': element.ReponseFromXero,
          'ErrorMessage': element.ErrorMessage
        });
      this.qboResponseLabel=label
    });

    this.dialogEditVisible = true;
    this.getDocumentToBill();
  }

  postToClear() {
    this.spinner.hide();
    this.msgs = [];
    this.getDocumentToBill();
  }

  

  sucess(resp: any) {
    console.log(resp);

  }

  failed(resp: any) {
    console.log(resp);

  }

  failedCreateBill(resp: any) {
    this.spinner.hide();
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: 'Failed', detail: 'Please reconnect your company and again post your document...' });

  }

  showHideViewer() {
    this.isViewerHidden = !this.isViewerHidden;
  }

  getRecordClass(index: any, docType: any) {
    if (docType == "CreditNote") {
      return 'creditNote'
    }
    else {
      return (index % 2 === 0) ? 'odd' : 'even';
    }

  }


}